<app-uni-page [parent]="this" pageTitle="QuickBooks Audit" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"/>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full" *ngIf="isPageReady">

    <div class="qb-list-actions flex items-end gap-3">
      <div class="flex flex-col">
        <label class="text-sm mb-1" for="qbAuditStart">Start Date</label>
        <p-datepicker inputId="qbAuditStart" [(ngModel)]="startDate" [disabled]="isLoading" />
      </div>
      <div class="flex flex-col">
        <label class="text-sm mb-1" for="qbAuditEnd">End Date</label>
        <p-datepicker inputId="qbAuditEnd" [(ngModel)]="endDate" [disabled]="isLoading" />
      </div>

      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-search"
              [loading]="isLoading" [disabled]="isLoading" (click)="runAudit()">
        <span>{{ isLoading ? 'Running...' : 'Run Audit' }}</span>
      </button>

      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-file-excel"
              [disabled]="!canExport" (click)="exportToExcel()">
        <span>Export to Excel</span>
      </button>

      <div class="flex items-center gap-2 ml-4" *ngIf="result">
        <p-checkbox inputId="qbAuditProblemsOnly" [(ngModel)]="problemsOnly" [binary]="true"
                    (onChange)="applyFilter()"></p-checkbox>
        <label for="qbAuditProblemsOnly" class="text-sm">Show only the documents that do not agree</label>
      </div>

      <span *ngIf="isLoading" class="text-sm flex items-center gap-2">
        <i class="pi pi-spin pi-spinner"></i>
        The system compares Uniformax to QuickBooks. A wide date range takes longer.
      </span>
    </div>

    <div *ngIf="result && !isLoading" class="px-4 pb-3 shrink-0">
      <div class="qb-detail-card qb-primary-tint p-4">
        <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">
          Tie-out — compare these totals against your QuickBooks report for the same period
        </div>

        <table class="qb-info-table w-full">
          <tr class="font-semibold">
            <td class="label">Document type</td>
            <td class="value text-right">Uniformax count</td>
            <td class="value text-right">QuickBooks count</td>
            <td class="value text-right">Uniformax total</td>
            <td class="value text-right">QuickBooks total</td>
            <td class="value text-right">Difference</td>
            <td class="value text-right">Do not agree</td>
          </tr>
          <tr *ngFor="let s of summaries">
            <td class="label">{{ s.DocType }}</td>
            <td class="value text-right">{{ s.LocalCount }}</td>
            <td class="value text-right">{{ s.QbCount }}</td>
            <td class="value text-right">{{ s.LocalTotal | currency }}</td>
            <td class="value text-right">{{ s.QbTotal | currency }}</td>
            <td class="value text-right">{{ s.Difference | currency }}</td>
            <td class="value text-right">{{ s.ProblemCount }}</td>
          </tr>
          <tr *ngIf="summaries.length === 0">
            <td class="value" colspan="7">The system found no documents in this period.</td>
          </tr>
          <tr *ngIf="summaries.length > 1" class="font-semibold">
            <td class="label">All types</td>
            <td class="value text-right"></td>
            <td class="value text-right"></td>
            <td class="value text-right">{{ grandLocalTotal | currency }}</td>
            <td class="value text-right">{{ grandQbTotal | currency }}</td>
            <td class="value text-right">{{ grandQbTotal - grandLocalTotal | currency }}</td>
            <td class="value text-right">{{ result.ProblemCount }}</td>
          </tr>
        </table>

        <div *ngFor="let note of result.Notes" class="text-sm mt-2">{{ note }}</div>
      </div>
    </div>

    <app-ag-grid [gridOptions]="gridOptions" [rowData]="documents" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()"><span>Go Back</span></button>
  </div>
</ng-template>
